import { CaseResponse, CaseState } from '@/types/types';

export const getCallbacksCount = (data: CaseResponse) => {
	let callbackCount = 0;
	if (data) {
		data.complaints?.forEach((complaint) => (callbackCount += complaint.callbacks?.length || 0));
		return callbackCount;
	}
	return 0;
};
export const getCaseVoteEnde = (data: CaseResponse, formatDate: (date: string, format?: string) => string) => {
	if (data) {
		if ((data.state === CaseState.ExaminationSmallSenate || data.state === CaseState.ExaminationSmallSenateRunning) && data.preVoteEndDate) {
			return formatDate(data.preVoteEndDate);
		} else if ((data.state === CaseState.ExaminationWerberat || data.state === CaseState.ExaminationWerberatRunning) && data.voteEndDate) {
			return formatDate(data.voteEndDate);
		}
	}
	return '-';
};

export const isSmallSenateDecision = (data: CaseResponse): boolean => {
	if (!data) return false;
	const hasPreVote = !!data.preVoteEndDate && !!data.preVoteStartDate;
	const isDecided = !!data.decidedDate;
	const hasStatementsDate = !!data.statementsDate;
	const hasNoVote = !!!data.voteStartDate && !!!data.voteEndDate;
	const finalStateIsUnfounded = data.state === CaseState.Unfounded;
	const wasSmallSenateDecision = hasPreVote && isDecided && hasStatementsDate && hasNoVote && finalStateIsUnfounded;
	return wasSmallSenateDecision;
};

export const hasDecision = (data: CaseResponse): boolean => {
	if (!data) return true;

	return [
		CaseState.DecisionSensitization,
		CaseState.DecisionNoReason,
		CaseState.DecisionStop,
		CaseState.ImmediateSubjectWithdrawal,
		CaseState.NotResponsible,
		CaseState.ProcedureNotPossible,
		CaseState.Unfounded,
	].includes(data.state);
};

export const isNotSentToSmallSenateYet = (data: CaseResponse): boolean => {
	if (!data) return true;
	return data.state === CaseState.NoStatus;
};

export const isSentToSmallSenate = (data: CaseResponse): boolean => {
	if (!data) return true;

	// false = nur wenn der Fall keinen Status hat und noch nicht an den kleinen Senat geschickt wurde
	return [CaseState.ExaminationSmallSenate, CaseState.ExaminationSmallSenateRunning].includes(data.state);
};

export const isInStatements = (data: CaseResponse): boolean => {
	if (!data) return false;

	return [CaseState.Statements].includes(data.state);
};

export const isSentToWerberat = (data: CaseResponse): boolean => {
	if (!data) return false;

	// bereits an den WR geschickt
	if (data.voteStartDate && data.voteEndDate) {
		return true;
	}

	return [CaseState.ExaminationWerberat, CaseState.ExaminationWerberatRunning].includes(data.state);
};
